import React, { useState } from 'react';
import { FaFileCode, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { tryParseCompositionJson } from './compositionImportUtils';

/** Intro tab only — full-episode composition import JSON. */
export default function CompositionJsonImport({
  busy = false,
  onImport,
  open: openControlled,
  onOpenChange,
}) {
  const [openInternal, setOpenInternal] = useState(false);
  const open = openControlled ?? openInternal;
  const setOpen = onOpenChange ?? setOpenInternal;
  const [jsonText, setJsonText] = useState('');

  const preview = tryParseCompositionJson(jsonText);
  const clipCount = preview.ok
    ? (preview.composition.sources || []).reduce(
        (n, s) => n + (s.vidclips || []).length,
        0,
      )
    : 0;
  const segCount = preview.ok
    ? (preview.composition.sections?.intro?.segment || []).length
    : 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!preview.ok) return;
    onImport?.(preview.composition, preview.warnings || []);
    setJsonText('');
  };

  return (
    <div className={`bulk-clip-import bulk-clip-import--compact ${open ? 'bulk-clip-import--open' : ''}`}>
      <button
        type="button"
        className="bulk-clip-import__toggle"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        title="Import composition JSON (Intro tab only)"
      >
        <FaFileCode aria-hidden="true" />
        <span>Import composition JSON</span>
        {!open && preview.ok && (
          <span className="bulk-clip-import__badge">{clipCount} clips · {segCount} segs</span>
        )}
        {open ? <FaChevronUp aria-hidden="true" /> : <FaChevronDown aria-hidden="true" />}
      </button>

      {open && (
        <form className="bulk-clip-import__panel" onSubmit={handleSubmit}>
          <p className="bulk-clip-import__hint">
            Full episode on <strong>Intro</strong>: tagged clips on Videos + one timeline
            (intro VO → clips → bridges → outro). JSON import drafts store a single section only.
          </p>
          <textarea
            className="bulk-clip-import__links"
            rows={8}
            placeholder='Paste composition_import.json (schemaVersion: 1)…'
            value={jsonText}
            onChange={e => setJsonText(e.target.value)}
            spellCheck={false}
          />
          {!preview.ok && jsonText.trim() && (
            <p className="bulk-clip-import__error" role="alert">{preview.error}</p>
          )}
          <button
            type="submit"
            className="btn-primary bulk-clip-import__submit"
            disabled={busy || !preview.ok}
          >
            {busy ? 'Applying…' : 'Apply to Intro'}
          </button>
        </form>
      )}
    </div>
  );
}
